<template lang="pug">
  JsonExcel(:data="dataForExcel" :leyPro='leyPro' type="xls" name="ENCABEZADOS_PRODUCTOS")
    v-btn(color='success' small dark @click='leyendaPro')
      v-icon(small) mdi-arrow-collapse-up
      | Productos
</template>
<script>
import JsonExcel from 'vue-json-excel'
export default {
  props: ['FormPadre', 'leyPro'],
  data: () => ({
    dataForExcel: [],
    form: []

  }),

  components: {
    JsonExcel
  },

  watch: {
    FormPadre (val) {
      if (Object.keys(val).length !== 0) {
        this.form = val
        this.generarExcel()
      }
    }
  },

  methods: {
    leyendaPro () {
      this.$emit('modiLeyPro')
    },

    generarExcel () {
      this.dataForExcel = []
      this.form.map(productos => {
        Object.keys(productos).forEach(function (key) {
          if (productos[key] === undefined || productos[key] === null) {
            productos[key] = ''
          }
        })
        let fila = {
          'nombre': ``,
          'descripcion': ``,
          'cantidadUnidadMedida': ``,
          'stock': ``,
          'costo': ``,
          'utilidad': ``,
          'stockMin': ``,
          'peso': ``,
          'alto': ``,
          'ancho': ``,
          'largo': ``,
        }
        this.dataForExcel.push(fila)
      })
    }
  }
}
</script>
